export default __webpack_public_path__ + "img/clipboard.0b70c4a1.svg";